import { render } from "./AtrList.vue?vue&type=template&id=3f6273a6&scoped=true"
import script from "./AtrList.vue?vue&type=script&lang=js"
export * from "./AtrList.vue?vue&type=script&lang=js"

import "./AtrList.vue?vue&type=style&index=0&id=3f6273a6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6273a6"]])

export default __exports__